import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BwEtree, BwEtreeService} from '../../generated';
import * as _ from 'lodash';
import {Schedule} from '../../models/Schedule';
import {FilterService, SelectItem} from 'primeng/api';
import {DatePipe} from '@angular/common';
import {BaseClientComponent} from '../base-client.component';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {QuincyEtree} from '../../models/QuincyEtree';
import {Company} from '../../models/company';
import {UserLogged} from '../../models/userLogged';
import {Table} from 'primeng/table';
import {TechnicalPopService} from '../../services/technical-pop.service';

@Component({
  selector: 'app-quincy-etrees-list',
  templateUrl: './quincy-etrees-list.component.html',
  styleUrls: ['./quincy-etrees-list.component.css']
})
export class QuincyEtreesListComponent extends BaseClientComponent implements OnInit, OnDestroy {
  @ViewChild('dataTableQuincyEtrees') dataTableQuincyEtrees: Table;

  currentCompany: Company;
  loggedInUser: UserLogged = null;
  quincyEtrees: Array<Schedule> = [];
  filteredQuincyEtrees: Array<Schedule> = [];
  formSelectValuesInjectionPops: SelectItem[] = [];
  formSelectValuesReceptionPops: SelectItem[] = [];
  loading = true;
  cols: any[];

  userChoicesFiltersDefaultQuincyEtrees = {
    name: null,
    crossConnect: null,
    vlan: null,
    injectionPop: null,
    receptionPops: null,
  };
  userChoicesActiveFiltersQuincyEtrees = _.clone(this.userChoicesFiltersDefaultQuincyEtrees);

  constructor(
    public route: ActivatedRoute,
    public BwEtreesService: BwEtreeService,
    public datePipe: DatePipe,
    public authenticationService: AuthenticationService,
    protected utilsService: UtilsService,
    protected technicalPopService: TechnicalPopService,
    protected http: HttpClient,
  ) {
    super();

    this.cols = [
      {field: 'name', header: 'Name', sortDisabled: false, class: ''},
      {field: 'marsInjectionPoint.site_technical_name', header: 'Injection Pop', sortDisabled: false, class: ''},
      {field: 'vlan', header: 'vlan', sortDisabled: false, class: ''},
      {field: 'marsInjectionCrossConnect', header: 'Injection cross connect', sortDisabled: false, class: ''},
      {field: 'receptionPointNames', header: 'Reception points', sortDisabled: false, class: ''},
      {field: 'actions', header: 'Actions', sortDisabled: true, class: ''},
    ];
  }

  ngOnInit() {
    this.utilsService.lockUi();
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.ngOnChanges();
    });
    FilterService['inCollection'] = (value: any[], filter: any): boolean => {
      if (filter === undefined || filter === null) {
        return true;
      }
      if (value === undefined || value === null || value.length === 0) {
        return false;
      }
      const commonValues = _.intersection(value, filter);
      return commonValues.length > 0;

    };
    this.subscriptions.push(response$);
  }

  public ngOnChanges() {
    this.loggedInUser = this.authenticationService.userCurrent;
    this.currentCompany = this.loggedInUser.company;
    this.userChoicesActiveFiltersQuincyEtrees = this.utilsService.loadUserPref('quincyEtreesFilter', _.clone(this.userChoicesFiltersDefaultQuincyEtrees));
    this.BwEtreesService.getBwEtreeCollection('MARS').subscribe({
      next: (etreesCollection) => {
        this.prepareQuincyEtreesList(etreesCollection);
        this.formSelectValuesInjectionPops = _.uniqBy(this.formSelectValuesInjectionPops, function (e) {
          return e.value;
        });
        this.formSelectValuesInjectionPops = _.sortBy(this.formSelectValuesInjectionPops, ['label']);

        this.formSelectValuesReceptionPops = _.uniqBy(this.formSelectValuesReceptionPops, function (e) {
          return e.value;
        });
        this.formSelectValuesReceptionPops = _.sortBy(this.formSelectValuesReceptionPops, ['label']);
        this.applyFiltersOnDataTableItem();
        this.utilsService.unlockUi();
        this.loading = false;
      }, error: () => {
        this.utilsService.unlockUi();
        this.utilsService.displayMessage('The Quincy E-Trees could not be loaded', 'Please try again later.', 'error');
      }
    });
  }

  private prepareQuincyEtreesList(etrees) {
    _.forEach(etrees['member'], (etree: BwEtree) => {
      const quincyEtree = JSON.parse(etree.jsonData) as QuincyEtree;
      quincyEtree.marsInjectionCrossConnect = quincyEtree.marsInjectionCrossConnect || null;
      if (quincyEtree.marsInjectionPoint) {
        this.formSelectValuesInjectionPops.push({
          label: quincyEtree.marsInjectionPoint['site_technical_name'],
          value: quincyEtree.marsInjectionPoint['internal_uuid']
        });
      }
      if (quincyEtree.marsReceptionPoints) {
        _.forEach(quincyEtree.marsReceptionPoints, (marsReceptionPoints: any) => {
          quincyEtree.receptionPoints.push(marsReceptionPoints['internal_uuid']);
          this.formSelectValuesReceptionPops.push({
            label: marsReceptionPoints['site_technical_name'],
            value: marsReceptionPoints['internal_uuid']
          });
        });
      }
      quincyEtree.receptionPointNames = this.getQuincyEtreesReceptionPoints(quincyEtree, 'site_technical_name');
      this.quincyEtrees.push(quincyEtree);
    });
  }

  public onClickedResetFilter() {
    this.userChoicesActiveFiltersQuincyEtrees = _.clone(this.userChoicesFiltersDefaultQuincyEtrees);
    this.applyFiltersOnDataTableItem();
  }

  public filterAndReset() {
    this.applyFiltersOnDataTableItem();
    this.dataTableQuincyEtrees.reset();
  }

  public applyFiltersOnDataTableItem() {
    this.utilsService.saveUserData('quincyEtreesFilter',
      {
        'name': this.userChoicesActiveFiltersQuincyEtrees.name,
        'crossConnect': this.userChoicesActiveFiltersQuincyEtrees.crossConnect,
        'vlan': this.userChoicesActiveFiltersQuincyEtrees.vlan,
        'injectionPop': this.userChoicesActiveFiltersQuincyEtrees.injectionPop,
        'receptionPops': this.userChoicesActiveFiltersQuincyEtrees.receptionPops
      });
    this.filteredQuincyEtrees = this.quincyEtrees.filter(quincyEtree => this.filter(quincyEtree));
  }

  filter(quincyEtree) {
    return this.hasName(quincyEtree)
      && this.hasCrossConnect(quincyEtree)
      && this.hasVlan(quincyEtree)
      && this.hasInjectionPop(quincyEtree)
      && this.hasReceptionPoints(quincyEtree);
  }

  public hasInjectionPop(quincyEtree) {
    if (!this.userChoicesActiveFiltersQuincyEtrees.injectionPop || this.userChoicesActiveFiltersQuincyEtrees.injectionPop === '') {
      return true;
    }

    return quincyEtree.marsInjectionPoint['internal_uuid'] === this.userChoicesActiveFiltersQuincyEtrees.injectionPop;
  }

  public hasReceptionPoints(quincyEtree) {
    if (!this.userChoicesActiveFiltersQuincyEtrees.receptionPops || this.userChoicesActiveFiltersQuincyEtrees.receptionPops === '') {
      return true;
    }

    const etreesReceptionPoints = this.getQuincyEtreesReceptionPoints(quincyEtree, 'internal_uuid');
    for (const receptionPop of this.userChoicesActiveFiltersQuincyEtrees.receptionPops) {
      if (!etreesReceptionPoints.includes(receptionPop)) {
        return false;
      }
    }
    return true;
  }

  public hasName(quincyEtree) {
    if (!this.userChoicesActiveFiltersQuincyEtrees.name || this.userChoicesActiveFiltersQuincyEtrees.name === '') {
      return true;
    }
    return quincyEtree.name.toLowerCase().includes(this.userChoicesActiveFiltersQuincyEtrees.name.toLowerCase());
  }

  public hasCrossConnect(quincyEtree) {
    if (!this.userChoicesActiveFiltersQuincyEtrees.crossConnect || this.userChoicesActiveFiltersQuincyEtrees.crossConnect === '') {
      return true;
    }
    if (!quincyEtree.marsInjectionCrossConnect && quincyEtree.marsInjectionCrossConnect !== false) {
      return false;
    }
    return quincyEtree.marsInjectionCrossConnect.toString().toLowerCase().includes(this.userChoicesActiveFiltersQuincyEtrees.crossConnect.toLowerCase());
  }

  public hasVlan(quincyEtree) {
    if (!this.userChoicesActiveFiltersQuincyEtrees.vlan || this.userChoicesActiveFiltersQuincyEtrees.vlan === '') {
      return true;
    }

    if (!quincyEtree.vlan) {
      return false;
    }
    return quincyEtree.vlan.toString().includes(this.userChoicesActiveFiltersQuincyEtrees.vlan);
  }

  public getQuincyEtreesReceptionPoints(quincyEtree: QuincyEtree, displayNameOrUniqid) {
    const receptionPops = [];
    if (quincyEtree.marsReceptionPoints.length > 0) {
      _.forEach(quincyEtree.marsReceptionPoints, (receptionPoint: any) => {
        receptionPops.push(receptionPoint[displayNameOrUniqid]);
      });
      return receptionPops.join(', ');
    }
    return '-';
  }
}

